import { Component, ChangeDetectionStrategy, inject, computed } from '@angular/core';

import type { WebLegacyWidgetEntity } from '@web/types';

import { WebWidgetBoundaryService } from '@web/core/services/web-widget-boundary.service';

import type { ColumnType } from '../base-column.abstract';
import { BaseColumnComponent } from '../base-column.abstract';
import { ZeroSignalWidgetComponent } from '../../widgets/zero-signal-widget/zero-signal-widget.component';

@Component({
    selector: 'web-zero-column',
    templateUrl: './zero-column.component.html',
    styleUrls: ['./zero-column.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ZeroSignalWidgetComponent],
})
export class ZeroColumnComponent extends BaseColumnComponent {
    public readonly columnType: ColumnType = 'zero';

    private readonly widgetBoundaryService = inject(WebWidgetBoundaryService);

    public readonly widgets = computed<WebLegacyWidgetEntity[]>(() => this.entity().children);

    public readonly showColumnHorizontalCenter = computed<boolean>(
        () => this.widgetBoundaryService.columnHorizontalCenterId() === this.entity().id
    );
    public readonly showColumnVerticalCenter = computed<boolean>(
        () => this.widgetBoundaryService.columnVerticalCenterId() === this.entity().id
    );
}
